import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I'm <span className="purple">Jamshaid Ahmed</span> from{" "}
            <span className="purple">Islamabad, Pakistan</span>.
            <br />
            <span className="purple">B.S. Computer Science graduate</span> from
            Quaid-i-Azam University (2025).
            <br />
            Full-stack developer specializing in{" "}
            <span className="purple">
              React, Next.js, and Python (Django/FastAPI)
            </span>{" "}
            for scalable web applications, with additional experience in{" "}
            <span className="purple">React Native</span> for cross-platform
            solutions.
            <br />
            <br />
            Professional experience includes:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight />{" "}
              <span className="purple">Software Development Intern</span> at
              National Center for Physics
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Programming Tutor</span>{" "}
              for SuperProf (Australia-based platform)
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Innovation Lead</span>{" "}
              at Google Developer Students Club
            </li>
          </ul>

          <p style={{ margin: "20px 0" }}>My passion extends to:</p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Building{" "}
              <span className="purple">AI-driven web and mobile solutions</span>
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Mentoring</span> in
              modern full-stack development
            </li>
            <li className="about-activity">
              <ImPointRight /> Creating{" "}
              <span className="purple">cross-platform user experiences</span>{" "}
              with MERN and Python
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)", marginTop: "20px" }}>
            "Building impactful solutions by blending creativity with clean
            code."
          </p>
          <footer className="blockquote-footer">Jamshaid</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
